import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMq from 'vue-mq'
import Photoswipe from 'vue-pswipe'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faVideo, faImage, faImages, faHourglassHalf, faEye, faMapMarkedAlt, faLink, faAngry } from '@fortawesome/free-solid-svg-icons'
// import { faImages } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faVideo, faImage, faImages, faHourglassHalf, faEye, faMapMarkedAlt, faLink, faAngry)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,
    tablet: 1023,
    laptop: 1215,
    desktop: Infinity
  }
})

Vue.use(Photoswipe)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
